// Rapor faturalandırma durumu. 0 = "işlem yapılmadı"; bu durumda sunucuda satır AÇILMAZ,
// grid LEFT JOIN sonucu 0 döner.
const ReportBillingStatusEnum = {
    NONE: 0,
    TO_BE_BILLED: 1,
    RECONCILED: 2,
    BILLED: 3,
    NOT_MATCHED: 4,
    DUPLICATE: 5,
}

// Durumun kaynağı (log kaydındaki Source).
export const ReportBillingSourceEnum = {
    MANUAL: 1,
    CSV_RECONCILIATION: 2,
    FINALIZATION: 3,
}

const STATUS_KEYS = {
    [ReportBillingStatusEnum.NONE]: 'BILLING_STATUS_NONE',
    [ReportBillingStatusEnum.TO_BE_BILLED]: 'BILLING_STATUS_TO_BE_BILLED',
    [ReportBillingStatusEnum.RECONCILED]: 'BILLING_STATUS_RECONCILED',
    [ReportBillingStatusEnum.BILLED]: 'BILLING_STATUS_BILLED',
    [ReportBillingStatusEnum.NOT_MATCHED]: 'BILLING_STATUS_NOT_MATCHED',
    [ReportBillingStatusEnum.DUPLICATE]: 'BILLING_STATUS_DUPLICATE',
}

const SOURCE_KEYS = {
    [ReportBillingSourceEnum.MANUAL]: 'BILLING_SOURCE_MANUAL',
    [ReportBillingSourceEnum.CSV_RECONCILIATION]: 'BILLING_SOURCE_CSV',
    [ReportBillingSourceEnum.FINALIZATION]: 'BILLING_SOURCE_FINALIZATION',
}

// antd Tag renkleri: nötr → mavi → turuncu → yeşil (tamamlandı), sorunlular kırmızı/mor.
const STATUS_COLORS = {
    [ReportBillingStatusEnum.NONE]: 'default',
    [ReportBillingStatusEnum.TO_BE_BILLED]: 'blue',
    [ReportBillingStatusEnum.RECONCILED]: 'orange',
    [ReportBillingStatusEnum.BILLED]: 'green',
    [ReportBillingStatusEnum.NOT_MATCHED]: 'red',
    [ReportBillingStatusEnum.DUPLICATE]: 'purple',
}

export const billingStatusKey = (status) => STATUS_KEYS[status ?? 0] || STATUS_KEYS[0]
export const billingStatusColor = (status) => STATUS_COLORS[status ?? 0] || 'default'
export const billingSourceKey = (source) => SOURCE_KEYS[source] || 'BILLING_SOURCE_MANUAL'

// Ekranda seçilebilir tüm durumlar (filtre ve toplu işlem menüsü aynı listeyi kullanır).
export const BILLING_STATUS_LIST = [
    ReportBillingStatusEnum.NONE,
    ReportBillingStatusEnum.TO_BE_BILLED,
    ReportBillingStatusEnum.RECONCILED,
    ReportBillingStatusEnum.BILLED,
    ReportBillingStatusEnum.NOT_MATCHED,
    ReportBillingStatusEnum.DUPLICATE,
]

export default ReportBillingStatusEnum
